
export const getJwtTokenFromlocalStorage = () => {
    return localStorage.getItem("token");
};

export const clearAllPropsFromlocalStorage = () => {
    localStorage.clear()
};

export const disableBackNavigation = () => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
    };
};

export function setlocalItem(key, value) {
    if (key && value !== undefined) {
        localStorage.setItem(key, value);
    }
}

export function getlocalItem(key) {
    const value = localStorage.getItem(key);
    try {
        return value ? value : null;
    } catch (error) {
        return value; 
    }
}

export function clearlocalStorage() {
    localStorage.clear();
}

export function removelocalItem(key) {
    localStorage.removeItem(key);
}